import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRetouch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRetouch"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C13.3748 2 14.6806 2.2939 15.8604 2.81934L13.5 4V5L16.5 6.5L18 9.5H19L20.3057 6.8877C21.0658 8.25361 21.5 9.82591 21.5 11.5V21H2.5V11.5C2.5 6.25329 6.75329 2 12 2ZM7 10V14.5C7 17.2614 9.23858 19.5 12 19.5C14.7614 19.5 17 17.2614 17 14.5V10H7Z" fill="currentColor"/><Path d="M18.5 1L19.4453 3.55468L22 4.5L19.4453 5.44532L18.5 8L17.5547 5.44532L15 4.5L17.5547 3.55468L18.5 1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRetouch;
